import { Video } from '../../../api';

export const getSortedGames = (games: Video[]) => {
  return [...games].sort((a, b) => {
    return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
  });
};
